'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./field.css');

var _ = require('../../');

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoField = function (_Component) {
	_inherits(GeckoField, _Component);

	function GeckoField() {
		var _ref, _this$types;

		var _temp, _this, _ret;

		_classCallCheck(this, GeckoField);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoField.__proto__ || Object.getPrototypeOf(GeckoField)).call.apply(_ref, [this].concat(args))), _this), _this.types = (_this$types = {}, _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_ADDRESS, _types.GeckoFieldAddress), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_CHECKBOX, _types.GeckoFieldCheckbox), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_COLOR, _types.GeckoFieldColor), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_CUSTOM, _types.GeckoFieldCustom), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_DATE, _types.GeckoFieldDate), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_DISPLAY, _types.GeckoFieldDisplay), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_EMAIL, _types.GeckoFieldText), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_NAME, _types.GeckoFieldName), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_NUMBER, _types.GeckoFieldNumber), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_PASSWORD, _types.GeckoFieldPassword), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_RADIO, _types.GeckoFieldRadio), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_RICH_TEXT, _types.GeckoFieldRichtext), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_SEARCH, _types.GeckoFieldSearch), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_SELECT, _types.GeckoFieldSelect), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI, _types.GeckoFieldSelectCreateMulti), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI, _types.GeckoFieldSelectMulti), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_TELEPHONE, _types.GeckoFieldTelephone), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_TEXT, _types.GeckoFieldText), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_TEXTAREA, _types.GeckoFieldTextarea), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_TITLE, _types.GeckoFieldText), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_TOGGLE, _types.GeckoFieldToggle), _defineProperty(_this$types, _.GECKO_CONSTS.FIELD_TYPE_URL, _types.GeckoFieldText), _this$types), _temp), _possibleConstructorReturn(_this, _ret);
	}

	// Map field types to field components


	_createClass(GeckoField, [{
		key: 'field',
		value: function field() {
			return this.props.field;
		}
	}, {
		key: 'type',
		value: function type() {
			return this.field().type || _.GECKO_CONSTS.FIELD_TYPE_TEXT;
		}
	}, {
		key: 'renderClasses',
		value: function renderClasses() {
			var errors = this.errors();
			return _.GECKO_UTILS.classNames('gecko-ui-field gecko-ui-field-type-' + this.type() + ' ' + (errors.length ? 'has-errors' : ''));
		}
	}, {
		key: 'renderLabelId',
		value: function renderLabelId() {
			return 'field_' + this.field().key + '_label';
		}
	}, {
		key: 'renderLabelFor',
		value: function renderLabelFor() {
			return 'field_' + this.field().key;
		}
	}, {
		key: 'isRequired',
		value: function isRequired() {
			return this.field().required || (this.field().requiredWhen ? this.field().requiredWhen() : false);
		}
	}, {
		key: 'renderRequired',
		value: function renderRequired() {
			if (this.isRequired()) return _react2.default.createElement(
				'span',
				{ className: 'required' },
				'*'
			);
			return null;
		}
	}, {
		key: 'renderField',
		value: function renderField() {
			var Field = this.types[this.type()];
			return _react2.default.createElement(Field, { field: this.field(), values: this.props.values, handler: this.props.handler.bind(this) });
		}
	}, {
		key: 'renderDescription',
		value: function renderDescription() {
			if (this.field().description) {
				return _react2.default.createElement(
					'p',
					{ className: 'description' },
					this.field().description
				);
			}
			return null;
		}
	}, {
		key: 'errors',
		value: function errors() {
			var _this2 = this;

			var extractErrors = function extractErrors(errors) {
				if (typeof errors === 'function') {
					return extractErrors(errors(_this2.props.values[_this2.field().key], _this2.field(), _this2.props.values));
				}
				if (Array.isArray(errors)) {
					return errors;
				}
				if (errors) {
					return [errors];
				}
				return [];
			};
			return extractErrors.bind(this)(this.field().errors); // not sure why I need to bind this here.
		}
	}, {
		key: 'renderErrors',
		value: function renderErrors() {
			var errors = this.errors();
			if (!errors.length) {
				return null;
			}
			return _react2.default.createElement(
				'ul',
				{ className: 'errors-list' },
				errors.map(function (err) {
					return _react2.default.createElement(
						'li',
						{ key: err },
						'* ',
						err
					);
				})
			);
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.field()) {
				return _react2.default.createElement(
					'div',
					{ className: this.renderClasses() },
					_react2.default.createElement(
						'label',
						{ id: this.renderLabelId(), htmlFor: this.renderLabelFor(), className: 'control-label' },
						_react2.default.createElement(
							'span',
							null,
							this.field().label
						),
						this.renderRequired()
					),
					this.renderField(),
					this.renderDescription(),
					this.renderErrors()
				);
			}
			return null;
		}
	}]);

	return GeckoField;
}(_react.Component);

GeckoField.defaultProps = {
	field: {},
	values: {},
	handler: function handler() {},
	onBlur: function onBlur() {}
};

GeckoField.propTypes = {
	field: _propTypes2.default.shape(_.GeckoFieldModel).isRequired,
	handler: _propTypes2.default.func,
	onBlur: _propTypes2.default.func
};

exports.default = GeckoField;